import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { updateDelegateConfigurationUrl, getDelegateConfigurationDetailsUrl, UPDATE_DELEGATE_CONFIGURATION, GET_DELEGATE_CONFIGURATION_DETAILS, headers } from "../../../../utils/constants";


export const updateDelegateConfiguration_action = (ExihibitionID, IsPaidDelegateRegistration, DelegateRegFeeInUSD, IsGSTIncluded, VisaApprovalLastDate) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            IsPaidDelegateRegistration: IsPaidDelegateRegistration,
            DelegateRegFeeInUSD: DelegateRegFeeInUSD,
            IsGSTIncluded: IsGSTIncluded,
            VisaApprovalLastDate: VisaApprovalLastDate,
        }

        const res = await axiosPost(updateDelegateConfigurationUrl, params, headers)

        dispatch({
            type: UPDATE_DELEGATE_CONFIGURATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateConfigurationDetails_action = (ExhibitionID,) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }

        const res = await axiosGet(getDelegateConfigurationDetailsUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_CONFIGURATION_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}